import { useEffect, useState } from "react";
import { SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import api from "@/lib/api";
import { TONE_OPTIONS } from "@/lib/autopilot";
import { cn } from "@/lib/utils";

const SPACINGS = [0, 10, 20, 30, 60, 120];

export default function OptionsCard({ cfg, save }) {
  const [f, setF] = useState(cfg);
  const [tags, setTags] = useState([]);
  useEffect(() => setF(cfg), [cfg]);
  useEffect(() => { api.get("/groups").then((r) => setTags([...new Set(r.data.map((g) => g.tag || "Umum"))].sort())).catch(() => {}); }, []);
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const toggleTag = (t) => set("tags", f.tags.includes(t) ? f.tags.filter((x) => x !== t) : [...f.tags, t]);
  const submit = () => save({ tone: f.tone, daily_limit: Number(f.daily_limit), start_time: f.start_time, spacing_minutes: f.spacing_minutes, use_best_time: f.use_best_time, tags: f.tags }, "Tetapan Autopilot disimpan");

  return (
    <section className="panel fade-up p-6" data-testid="autopilot-options-card">
      <h2 className="flex items-center gap-2 font-bold"><SlidersHorizontal className="h-4 w-4 text-primary" /> Jadual harian</h2>
      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        <div className="space-y-2"><Label>Gaya ayat</Label>
          <Select value={f.tone} onValueChange={(v) => set("tone", v)}>
            <SelectTrigger className="bg-background" data-testid="autopilot-tone-select"><SelectValue /></SelectTrigger>
            <SelectContent>{TONE_OPTIONS.map((t) => <SelectItem key={t.v} value={t.v}>{t.l}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div className="space-y-2"><Label>Had group sehari (1-30)</Label>
          <Input type="number" min={1} max={30} value={f.daily_limit} onChange={(e) => set("daily_limit", e.target.value)} className="bg-background" data-testid="autopilot-daily-limit-input" />
        </div>
        <div className="space-y-2"><Label>Mula post pada</Label>
          <Input type="time" value={f.start_time} onChange={(e) => set("start_time", e.target.value)} className="bg-background" data-testid="autopilot-start-time-input" />
        </div>
        <div className="space-y-2"><Label>Jarak antara group</Label>
          <Select value={String(f.spacing_minutes)} onValueChange={(v) => set("spacing_minutes", Number(v))}>
            <SelectTrigger className="bg-background" data-testid="autopilot-spacing-select"><SelectValue /></SelectTrigger>
            <SelectContent>{SPACINGS.map((m) => <SelectItem key={m} value={String(m)}>{m === 0 ? "Serentak" : `${m} minit`}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between rounded-lg border border-border p-4">
        <div><p className="text-sm font-medium">Guna masa terbaik AI</p><p className="text-xs text-muted-foreground">Jika ada cadangan masa untuk group, ia mengatasi masa mula</p></div>
        <Switch checked={f.use_best_time} onCheckedChange={(v) => set("use_best_time", v)} data-testid="autopilot-best-time-toggle" />
      </div>
      <div className="mt-4">
        <Label>Tag group (kosong = semua group aktif)</Label>
        <div className="mt-2 flex flex-wrap gap-2" data-testid="autopilot-tags">
          {tags.map((t) => (
            <button key={t} type="button" onClick={() => toggleTag(t)} data-testid={`autopilot-tag-${t}`}
              className={cn("rounded-full border px-3 py-1 text-xs transition-colors", f.tags.includes(t) ? "border-primary/60 bg-primary/15 text-white" : "border-border text-muted-foreground hover:text-white")}>
              {t}
            </button>
          ))}
        </div>
      </div>
      <Button className="mt-5" onClick={submit} data-testid="autopilot-save-options-btn">Simpan</Button>
    </section>
  );
}
